export function getBrokerDetailsEndpoint(brokerBusinessPartnerId: string): string {
    return `/broker-details/${brokerBusinessPartnerId}`;
}
